export default __webpack_public_path__ + "static/our-team-tablet-3-7437f569a3a4ee8c84b50347e12a6756.png";